import { salt } from '../../../../@helpers';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
@inject("ChatBotStore")
@observer
class QuickReplies extends Component {

  render(){
    const { message, ChatBotStore: { handleQuickReply } } = this.props
    return (
      <Fragment>
        {message.text.map(quickreply => <button key={ salt() } type="button" onClick={ handleQuickReply } className="button">{quickreply.structValue.fields.text.stringValue}</button>)}
      </Fragment>
    )
  }
}

export default QuickReplies